declare var google: any;
declare var jQuery: any;

import { TObject } from "../../common/TObject";

export class ColorSelect extends TObject {

    buttonFrame: HTMLDivElement;
    private color: string = 'black';

    options:any= {};


    constructor(parent: any, options:any= {}) {
        super(parent);
        this.options = options;


        if (options.frame) {
            this.buttonFrame = options.frame;
        }

        if (!this.buttonFrame){
            this.buttonFrame = document.createElement("div");
     
        }
      
    

       

       

        jQuery(this.buttonFrame).colorpicker({format:'rgba',container: true,
        inline: true}).on('changeColor', (e)=> {
           this.set(e.color.toString(
            'rgba'));
        });


      



    }

    focus() {
      
    }

    get() {
        return jQuery(this.buttonFrame).colorpicker('getValue');
    }

    set(value) {
        this.debug('>set',value,this.color);
        if (this.color != value) {
            this.color = value;
          
             jQuery(this.buttonFrame).colorpicker('setValue', value);
             this.changed();
        }
    }


}